module.exports = __webpack_public_path__ + "static/media/ge.c77df6c7.svg";